import $ from 'jquery';

export class SearchBox {
  constructor($el) {
    this.$el = $el;
    this.bindEvents();
  }

  bindEvents() {
    this.$el.on('click', '.js-search-toggle', event => this.onButtonClick(event));
  }
  
  onButtonClick(event) {
    this.toggleSearchInput();
  }
  
  toggleSearchInput() {
    this.$el.toggleClass('is-open');
  }
  
  isOpen() {
    return this.$el.hasClass('is-open');
  }
}
